import { useAuth } from "../../../hooks/useAuth";

const Authenticated = ({ children }: { children: React.ReactNode }) => {
  const { token } = useAuth();

  return <>{token ? children : null}</>;
};

export default Authenticated;
